import {Action} from "../../../action/action";
import type {MoveBookingState} from "../moveBookingState";

export class Next extends Action<"NEXT_STATE", undefined> {
  readonly type = "NEXT_STATE";
  protected state: MoveBookingState;

  constructor(state: MoveBookingState) {
    super(state);
    this.state = state;
  }
  /**
   * Business Logic:
   * This action is available if there isn't any payment left to be handled.
   * If there's payment to be handled, the user has to choose a PaymentMethod.
   * @returns
   */
  public isDoable(): boolean {
    const {date, time, dependencies} = this.state.getData();
    if (!date || !time || !dependencies) return false;
    const {partner, service} = dependencies;
    const partnerByService = service.getPartnersBy().find((p) => p.id === partner.id);
    if (!partnerByService) return false;

    const partnersTimeslots = partnerByService.schedule.timeslotsByDay(date, service.duration);

    const partnerHasTimeslots = partnersTimeslots.length > 0;

    return partnerHasTimeslots;
  }

  public isValid(): boolean {
    return this.isDoable();
  }
}
